import * as React from "react";
import {observer} from "mobx-react-lite";
import {
    CButton,
    CCard,
    CCardContent,
    CContainer,
    CGrid,
    CGridContainer, CH3,
    CTextField
} from "../../components";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import {hasValue} from "../../utils/empty-check";
import {isEmpty} from "validate.js";
import 'firebase/compat/firestore';
import {CCircularProgress} from "../../components/mui-extracted/circular-progress";
import {useStores} from "../../models";
import {cast} from "mobx-state-tree";
import {Staff} from "../../models/staff/staff";

export const ProjectSetup = observer(
    function ProjectSetup() {

        const navigate = useNavigate();
        const {authStore, projectStore, businessStore} = useStores();

        const [formData, setFormData] = useState({
            name: "",
            walletAddress: "",
        })

        const [formDataValidationMessages, setFormDataValidationMessages] = useState({
            name: "",
            walletAddress: "",
        })

        const [isAddingProject, setIsAddingProject] = useState(false)

        const isValid = () => {

            let output = true

            const currentFormDataValidationMessages = {
                ...formDataValidationMessages
            }

            if (isEmpty(formData.name)) {
                currentFormDataValidationMessages.name = "Name is required."
                output = false
            }

            if (isEmpty(formData.walletAddress)) {
                currentFormDataValidationMessages.walletAddress = "Wallet Address is required."
                output = false
            }

            if (!output) {
                setFormDataValidationMessages(currentFormDataValidationMessages)
            }

            return output
        }

        const submit = async () => {
            if (isValid() && businessStore.business !== undefined) {
                setIsAddingProject(true)

                await projectStore.addProject(formData, businessStore.business.id, true,authStore.staff as Staff);

                setIsAddingProject(false)
                navigate('/panel/projects')
            }
        }

        return (
            <>
                <main style={{minHeight: '100vh'}}>
                    <CContainer
                        style={{display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center'}}>
                        <CCard sx={{width: 500}}>
                            <CCardContent sx={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}>

                                <CGridContainer>
                                    <CGrid item xs={12}>
                                        <CH3 sx={(theme) => ({
                                            fontWeight: 900,
                                            mb: 2,
                                            color: theme.palette.primary.light
                                        })}>
                                            Setup First Project
                                        </CH3>
                                    </CGrid>
                                    <CGrid item xs={12}>
                                        <CTextField
                                            fullWidth
                                            error={hasValue(formDataValidationMessages.name)}
                                            helperText={formDataValidationMessages.name}
                                            label="Name"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.name}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    name: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={12}>
                                        <CTextField
                                            fullWidth
                                            error={hasValue(formDataValidationMessages.walletAddress)}
                                            helperText={formDataValidationMessages.walletAddress}
                                            label="Wallet Address"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.walletAddress}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    walletAddress: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6} sx={{mt: 2}}>
                                        {
                                            isAddingProject ? <CCircularProgress/> :
                                                <CButton disabled={isAddingProject} size="medium" variant="contained"
                                                         onClick={() => submit()}>
                                                    ProjectSetup
                                                </CButton>
                                        }

                                    </CGrid>

                                </CGridContainer>


                            </CCardContent>
                        </CCard>
                    </CContainer>
                </main>
            </>
        );
    }
)
